import { motion } from "framer-motion";
import { SITE } from "@/lib/site";

export default function WhyChooseUs() {
  return (
    <section
      id="why"
      data-testid="why-us-section"
      className="relative py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-10 items-end mb-14 md:mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="md:col-span-12 font-display text-4xl md:text-6xl tracking-tighter leading-[0.98]"
          >
            Nanded ke logon ka bharosa.{" "}
            <span className="italic font-light text-white/60">
              Quality, service aur genuine products — bina compromise.
            </span>
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {SITE.whyUs.map((w, i) => (
            <motion.div
              key={w.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{
                duration: 0.8,
                delay: i * 0.06,
                ease: [0.22, 1, 0.36, 1],
              }}
              whileHover={{ y: -4 }}
              data-testid={`why-card-${i}`}
              className="group glass rounded-3xl p-7 md:p-8 hover:border-white/25 transition-[border-color] duration-500 relative overflow-hidden"
            >
              <div className="absolute -inset-16 bg-[radial-gradient(circle_at_30%_0%,rgba(29,82,196,0.25),transparent_55%)] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="relative z-10">
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl grad-bg text-white shadow-[0_10px_30px_-10px_rgba(29,82,196,0.6)] mb-6">
                  <span className="text-lg font-bold">✦</span>
                </div>
                <h3 className="font-display text-2xl md:text-[26px] tracking-tight leading-tight text-white">
                  {w.title}
                </h3>
                <p className="mt-3 text-white/60 text-sm leading-relaxed">
                  {w.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
